import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Routes, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { RetentionService } from '../../services/retention.service';
import { ListofvaluesService } from '../../services/listofvalues.service';
import { ProviderService } from '../../services/provider.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import * as fileSaver from 'file-saver';
import { LocalDataSource } from 'ng2-smart-table';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../../../shared';
import { CreateRetentionModalComponent } from './createRetentionModal/createRetentionModal.component';
import { WorkOrderService } from '../../services/work-order.service';
import { BudgetService } from '../../services/budget.service';
import { PDFService } from '../../services/pdf.service';
import { InternalService } from '../../services/internal.service'

@Component({
  selector: 'app-new-retention',
  templateUrl: 'new-retention.component.html',
  styleUrls: ['new-retention.component.scss'],
  providers: [RetentionService, ListofvaluesService, ProviderService, WorkOrderService, BudgetService, PDFService]
})
export class NewRetentionComponent implements OnInit {
  workOrderData: any;
  budgetData: any;
  paramId: number;
  budgetId: number;
  provider_email: string = null;
  fromBudget: boolean = false;
  RetentionHeaderData: any = {};
  RetentionDetailData: any = [];
  dataParams: any = undefined;
  tableSettingsRetentionDetail: any = undefined;
  dataSourceRetentionDetail: any = undefined;
  tableDataRetentionDetail: any = {};
  ldvMoney: any;
  providerName: string;
  listProviders: any = [];
  RetentionHeaderPrice: any;
  priceWithTax: any = 0;
  tax_text = 'IGV';
  filteredOptions: Observable<string[]>;
  myControlProviders = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  tax_percentage = '18%';
  tax_val: any = 0;
  providerComercialNameSelected: string;
  total: any = 0;
  dataToSend: any;
  perPage = 10;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'editar', title: `<div class="editCustomButton">Editar</div>` },
        { name: 'eliminar', title: `<div class="editCustomButton">Eliminar</div>` }
      ]
    }
  };

  constructor(
    private route: ActivatedRoute,
    private listofvaluesService: ListofvaluesService,
    private notifierService: NotifierService,
    private RetentionService: RetentionService,
    private providerService: ProviderService,
    private budgetService: BudgetService,
    private workOrderService: WorkOrderService,
    private pdfService: PDFService,
    public dialog: MatDialog,
    private internalService: InternalService,
    private routes: Router, private zone: NgZone) {
    this.listofvaluesService.getLdvByCode('TBWA-MONEY').subscribe((result) => {
      this.ldvMoney = result;
    });
    this.providerService.listProviders().subscribe((result: any) => {
      this.listProviders = result;

      this.listProviders.sort(function (a, b) {
        if (a.comercial_name < b.comercial_name) { return -1; }
        if (a.comercial_name > b.comercial_name) { return 1; }
        return 0;
      })


    });
    this.tableDataRetentionDetail = {
      columns: {
        doc_type_text: { title: 'Tipo Doc' },
        doc_number: { title: 'Num. Doc' },
        fecha_pago_text: { title: 'Fecha Pago' },
        currency_text: { title: 'Moneda' },
        monto_pago: { title: 'Monto Pago' },
        importe_retencion: { title: 'Monto Retención' },
        importe_pagar: { title: 'Monto Depositar' }

      },
      data: {}
    };
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.paramId = params['id'];

        this.RetentionService.getRetentionHeader(this.paramId).subscribe((Retention: any) => {
          this.RetentionHeaderData = Retention;
          console.log('buy ord', this.RetentionHeaderData)
          const found = this.listProviders.find((item) => {
            return item.id == Retention.id_provider;
          });
          //this.providerName = found.comercial_name;
          this.providerName = Retention.prov_comercial_name;
          console.log('buy ord', this.RetentionHeaderData)
          //this.provider_email = found.email;
          this.provider_email = Retention.prov_email;
          if (this.RetentionHeaderData.others == null || this.RetentionHeaderData.others == undefined) {
            this.RetentionHeaderData.others = 0;
          }
          


          this.RetentionService.getRetentionDetails(this.paramId).subscribe((RetentionDetails: any = []) => {
            this.RetentionDetailData = RetentionDetails;
            this.RetentionDetailData.forEach(element => {
              element.action_backend = 'E';
            });
            this.getTableData(this.RetentionDetailData);

          });

        });
      } else {
        this.paramId = undefined;
        this.RetentionHeaderData.id_provider = 1;
        this.RetentionHeaderData.tax = 1;
        this.RetentionHeaderData.currency = 7;
        this.RetentionHeaderData.product = '';
        this.RetentionHeaderData.project = '';
        this.RetentionHeaderData.others = 0;
        this.listofvaluesService.getLdvByCode('TBWA-LEGALTEXT-Retention').subscribe((textResult: any) => {
          this.RetentionHeaderData.terms = textResult[0].value;
        });
      }
    });


  }

  updateVals() {
    this.getTableData(this.RetentionDetailData);
  }
  ngOnInit() {

    this.filteredOptions = this.myControlProviders.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.getTableData([]);

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    //console.log(this.listProviders.filter(provider => provider.comercial_name.toLowerCase().includes(filterValue)))
    //console.log(this.options.filter(provider => provider.toLowerCase().includes(filterValue)))
    return this.listProviders.filter(provider => provider.comercial_name.toLowerCase().includes(filterValue));
  }


  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }
  exportPDF() {
    this.notifierService.systemNotify({
      title: 'Espere un momento',
      message: 'Descargando PDF',
      type: 'info',
      duration: 20000
    });

      this.pdfService.getPDFRetencion(this.paramId, 'PDF').subscribe(
        (result: any) => {
          const filename = 'RET_' + this.RetentionHeaderData.doc_number + '-'+ this.RetentionHeaderData.correlative +'.pdf';
          fileSaver.saveAs(result, filename);
          this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Se ha descargado el PDF.',
            type: 'success'
          });
        },
        error => {
          console.log(error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ha ocurrido un error al descargar el PDF',
            type: 'error',
            duration: 5000
          });
        });
    
  }

  exportXML(){
    this.notifierService.systemNotify({
      title: 'Espere un momento',
      message: 'Descargando XML',
      type: 'info',
      duration: 20000
    });

      this.pdfService.getPDFRetencion(this.paramId, 'XML').subscribe(
        (result: any) => {
          const filename = 'RET_' + this.RetentionHeaderData.doc_number + '-'+ this.RetentionHeaderData.correlative +'.xml';
          fileSaver.saveAs(result, filename);
          this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Se ha descargado el XML.',
            type: 'success'
          });
        },
        error => {
          console.log(error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ha ocurrido un error al descargar el XML',
            type: 'error',
            duration: 5000
          });
        });
    
  }
  getTableData(result) {

    this.RetentionHeaderPrice = 0;
    const cloneRows: Array<any> = [...result];

    for (const item of cloneRows) {

      //item.created_date = moment(item.created_date).format('DD/MM/YYYY');
      item.fecha_pago_text = moment(item.fecha_pago).format('DD/MM/YYYY');
      if (item.doc_type =='01'){
        item.doc_type_text = 'Factura';
      }else if (item.doc_type =='03'){
        item.doc_type_text = 'Boleta';
      }

      if (item.currency =='7'){
        item.currency_text = 'Soles';
      }else if (item.currency =='8'){
        item.currency_text = 'Dólares';
      }
      

      this.RetentionHeaderPrice += Number(item.price);
      item.price = Number(item.price).toFixed(2);
      item.price_string = this.budgetService.transformNumber(item.price);
    }

  
    this.RetentionHeaderPrice = Number(this.RetentionHeaderPrice).toFixed(2);
    this.RetentionHeaderPrice = this.budgetService.transformNumber(this.RetentionHeaderPrice);
    this.total = Number(Number(this.priceWithTax) + Number(this.RetentionHeaderData.others)).toFixed(2);
    this.total = this.budgetService.transformNumber(this.total);
    this.RetentionHeaderData.others = Number(this.RetentionHeaderData.others).toFixed(2);
    
    this.dataSourceRetentionDetail = new LocalDataSource(cloneRows);
    this.tableSettingsRetentionDetail = this.copyObject(this.settings);
    if (this.tableDataRetentionDetail.columns !== undefined) {
      this.tableSettingsRetentionDetail.columns = this.copyObject(this.tableDataRetentionDetail.columns);

      this.tableSettingsRetentionDetail.columns['monto_pago'] = {
        'title': this.tableSettingsRetentionDetail.columns['monto_pago'].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat" style="text-align:right"> ' + value + ' </div>';
        }
      };
      this.tableSettingsRetentionDetail.columns['importe_retencion'] = {
        'title': this.tableSettingsRetentionDetail.columns['importe_retencion'].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat" style="text-align:right"> ' + value + ' </div>';
        }
      };
      this.tableSettingsRetentionDetail.columns['importe_pagar'] = {
        'title': this.tableSettingsRetentionDetail.columns['importe_pagar'].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat" style="text-align:right"> ' + value + ' </div>';
        }
      };

      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsRetentionDetail.columns).forEach(key => {
        this.tableSettingsRetentionDetail.columns[key].filter = true;
      });
    }
  }

  onProviderSelected(provider) {
    this.RetentionHeaderData.id_provider = provider.id;
    console.log(this.listProviders.filter(item => item.id == provider.id));
    console.log(this.RetentionHeaderData);
  }

  openCreateObject() {
    this.notifierService.behaviorNotify({
      action: 'register',
      model: 'retention',
      object: { data: {} }
    });
    const deleteDialog = this.dialog.open(CreateRetentionModalComponent);
    deleteDialog.afterClosed().subscribe((result: any) => {
      if (result.action_backend === 'C') {
        let found = this.RetentionDetailData.find((item) => {
          return (item.create_uuid === result.create_uuid);
        });
        if (found) {
          found = result;
        } else {
          this.RetentionDetailData.push(result);
        }
        
      } else if (result.action_backend === 'U') {
        let found = this.RetentionDetailData.find((item) => {
          return (item.id === result.id);
        });
        if (found) {
          found = result;
        }
      }
      this.refreshTotal();
      this.getTableData(this.RetentionDetailData);
    });
  }
  refreshTotal(){
    if (this.RetentionDetailData.length > 0){
      this.RetentionHeaderData.importe_pago = 0;
      this.RetentionHeaderData.importe_retenido = 0;
      this.RetentionDetailData.forEach((element) => {
        this.RetentionHeaderData.importe_pago = (Number(this.RetentionHeaderData.importe_pago) + Number(element.importe_pagar));
        this.RetentionHeaderData.importe_retenido = Number(this.RetentionHeaderData.importe_retenido)+  Number(element.importe_retencion);
      });
      this.RetentionHeaderData.importe_pago =  parseFloat(this.RetentionHeaderData.importe_pago).toFixed(2);
      this.RetentionHeaderData.importe_retenido =  parseFloat(this.RetentionHeaderData.importe_retenido).toFixed(2);
    }else{
      this.RetentionHeaderData.importe_pago = 0;
      this.RetentionHeaderData.importe_retenido = 0;
    }
    
  }
  customAction(event) {

    switch (event.action) {
      case 'editar':
        this.notifierService.behaviorNotify({
          action: 'edit',
          model: 'retention',
          object: { data: event.data }
        });
        const dialogRef = this.dialog.open(CreateRetentionModalComponent);
        dialogRef.afterClosed().subscribe((result) => {
          //console.log('event', event);
          if (result) {
            if (event.data.action_backend === 'C') {
              const index = this.RetentionDetailData.findIndex((item) => {
                return item.create_uuid === event.data.create_uuid;
              });
              if (index) {
                this.RetentionDetailData.splice(index, 1, event.data);
              }
            } else {
              event.data.action_backend = 'U';
            }
          }
          this.zone.run(() => {
            this.getTableData(this.RetentionDetailData);
          });
        }, (error) => {
          console.log('error', error);
        });
        break;
      case 'eliminar':
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: 'exclamation-circle',
            iconColor: 'failure',
            title: 'Aviso',
            text: '¿Está seguro que desea eliminar?',
            options: true
          }
        });
        deleteDialog.afterClosed().subscribe((result) => {
          if (result) {
            if (event.data.action_backend === 'C') {
              const index = this.RetentionDetailData.findIndex((item) => {
                return item.create_uuid === event.data.create_uuid;
              });
              if (index !== undefined) {

                this.RetentionDetailData.splice(index, 1);
              }
            } else {
              event.data.action_backend = 'D';
              const idToDelete = this.RetentionDetailData.findIndex((toDelete) => {
                // tslint:disable-next-line:triple-equals
                return toDelete.id == event.data.id;
              });
              this.RetentionDetailData.splice(idToDelete, 1);
            }
          }

          this.zone.run(() => {
            this.getTableData(this.RetentionDetailData);
          });
        }, (error) => {
          console.log('error', error);
        });
        break;
    }


  }

  createRetention(form: NgForm) {
    if (form.valid) {
      console.log('to create', this.RetentionHeaderData);
      this.RetentionService.createRetentionHeader(this.RetentionHeaderData).subscribe((result: any) => {
        this.RetentionDetailData.forEach(element => {
          element.id_retencion_header = result.id;
        });
        this.RetentionService.insertBatch(this.RetentionDetailData).subscribe((listDetail) => {
          this.routes.navigate(['system/retention/edit/' + result.id]);
          this.notifierService.systemNotify({
            title: 'Éxito',
            message: 'Se ha creado el comprobante de retención',
            type: 'success'
          });
        }, (error) => {
          this.notifierService.systemNotify({
            title: 'Ha ocurrido un error',
            message: 'Por favor póngase en contacto con el administrador',
            type: 'error'
          });
        });
      });
    } else {
      this.notifierService.systemNotify({
        title: 'Ha ocurrido un error',
        message: 'Por favor llene los campos obligatorios',
        type: 'error'
      });
    }
  }
  anularRetention(form: NgForm) {
    this.RetentionService.voidRetentionHeader( this.paramId).subscribe((updateData) => {
        var obk = updateData;
          if (obk['tipo'] =='02'){
            this.notifierService.systemNotify({
              title: 'Ha ocurrido un error',
              message:  obk['retorno'],
              type: 'error'
            });
         //   this.routes.navigate(['system/retention/list/']);
          }else{
            this.notifierService.systemNotify({
              title: 'Éxito',
              message: 'Solicitar al administrador la liberación de la anulación',
              type: 'success'
            });
                          
            this.RetentionHeaderData.resultado_emision = '05';

          }
         
        
        
        
      }, (error) => {
          this.notifierService.systemNotify({
            title: 'Ha ocurrido un error',
            message: 'Por favor póngase en contacto con el administrador',
            type: 'error'
          });
        });
      
    
  
}
  emitirRetention(form: NgForm) {
      this.RetentionService.emitRetentionHeader( this.paramId).subscribe((updateData) => {
          var obk = updateData;
            if (obk['tipo'] =='02'){
              this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message:  obk['retorno'],
                type: 'error'
              });
           //   this.routes.navigate(['system/retention/list/']);
            }else{
              this.notifierService.systemNotify({
                title: 'Éxito',
                message:  obk['retorno'],
                type: 'success'
              });
                            
              this.RetentionHeaderData.fecha_emision = new Date();
              this.RetentionHeaderData.resultado_emision = '03';

            }
           
          
          
          
        }, (error) => {
            this.notifierService.systemNotify({
              title: 'Ha ocurrido un error',
              message: 'Por favor póngase en contacto con el administrador',
              type: 'error'
            });
          });
        
      
    
  }
  updateRetention(form: NgForm) {
    if (form.valid) {
      this.RetentionService.updateRetentionHeader(this.RetentionHeaderData).subscribe((updateData) => {
        this.RetentionDetailData.forEach(element => {
          element.id_retencion_header = this.paramId;
        });
        if (this.RetentionDetailData.length > 0) {
          this.RetentionService.InsertAllDetails(this.RetentionDetailData, this.paramId).subscribe((listDetail) => {
            this.notifierService.systemNotify({
              title: 'Éxito',
              message: 'Se ha actualizado el comprobante de retención',
              type: 'success'
            });
            this.routes.navigate(['system/retention/edit/' + this.paramId]);
          }, (error) => {
            this.notifierService.systemNotify({
              title: 'Ha ocurrido un error',
              message: 'Por favor póngase en contacto con el administrador',
              type: 'error'
            });
          });
        } else {
          this.notifierService.systemNotify({
            title: 'Éxito',
            message: 'Se ha actualizado el comprobante de retención',
            type: 'success'
          });
          this.routes.navigate(['system/retention/list']);
        }
      });
    }
  }



  sendMail() {

    this.RetentionHeaderData.created_date = new Date(this.RetentionHeaderData.created_date).toLocaleString().split(" ")[0];

    for (let index = 0; index < this.RetentionDetailData.length; index++) {
      this.RetentionDetailData[index].index = index + 1;
    }

    var textLegal = this.RetentionHeaderData.terms.split("-");
    textLegal.shift();

    const found = this.listProviders.find((element) => {
      // tslint:disable-next-line:triple-equals
      return element.id == this.RetentionHeaderData.id_provider;
    });
    this.RetentionHeaderData.provider_name = found.comercial_name

    this.listofvaluesService.getLdvByCode('TBWA-INFORMATION').subscribe((resInfo) => {
      const tempData = {
        workOrder: this.workOrderData,
        budgetHeader: this.budgetData,
        RetentionHeader: this.RetentionHeaderData,
        details: this.RetentionDetailData,
        totalPrice: this.RetentionHeaderPrice,
        taxVal: this.tax_val,
        whitTaxPrice: this.priceWithTax,
        taxText: this.tax_text,
        legal: textLegal,
        taxPercentage: this.tax_percentage,
        group: resInfo[0],
        ruc: resInfo[1],
        address: resInfo[2],
        subtotal: this.RetentionHeaderPrice,
        userCreate: this.RetentionHeaderData.user_name
      };

      this.RetentionService.sendMail(tempData, this.provider_email).subscribe((result) => {
        this.notifierService.systemNotify({
          title: 'Éxito',
          message: 'Se ha enviado el correo al proveedor',
          type: 'success'
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/retention/new-retention/new-retention.component.ts